module.exports = __webpack_public_path__ + "img/screens.4e5fdd1f.svg";